import {Component, OnInit, ViewChild} from '@angular/core';
import {TGiftVoucherTransferService} from './service/t-gift-voucher-transfer.service';
import {MainTGiftVoucherTransfer} from './model/t-gift-voucher-transfer';
import {SnotifyService} from 'ng-snotify';
import {TGiftVoucherTransferRequest} from './model/t-gift-voucher-transfer-request';
import {MBranchService} from '../../service/m-branch/service/m-branch.service';
import {MBranch} from '../../service/m-branch/model/m-branch';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import {Observable} from '../../../../../node_modules/rxjs';
import {MGiftvoucherPriceCategoryService} from '../../master-files/m-gift-voucher-price-category/service/m-gift-voucher-price-category.service';
import {MGiftVoucherPriceCategory} from '../../master-files/m-gift-voucher-price-category/model/m-gift-voucher-price-category';
import {MBulkGiftVoucherCustomerService} from '../../master-files/m-gift-voucher-bulk-customer/service/m-gift-voucher-customer.service';
import {MBulkGiftVoucherCustomer} from '../../master-files/m-gift-voucher-bulk-customer/model/m-bulk-gift-voucher-customer-dto';
import {TGiftVoucherTransferItem} from './model/t-gift-voucher-transfer-item';
import {MGiftVoucherService} from '../../master-files/m-gift-voucher/service/m-gift-voucher.service';
import {MGiftVoucher} from '../../master-files/m-gift-voucher/model/m-gift-voucher';
import {NgxSmartModalService} from 'ngx-smart-modal';
import {AppSettings} from '../../settings/app-settings';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-gift-voucher-transfer',
  templateUrl: './t-gift-voucher-transfer.component.html'
})
export class TGiftVoucherTransferComponent implements OnInit {

  private tGiftVoucherTransfer: MainTGiftVoucherTransfer;
  private tGiftVoucherTransferRequest: TGiftVoucherTransferRequest;
  private tGiftVoucherTransferItems: TGiftVoucherTransferItem[] = [];
  private mBranchs: MBranch [] = [];
  private mGiftVoucherPriceCategorys: MGiftVoucherPriceCategory[] = [];
  private mBulkGiftVoucherCustomers: MBulkGiftVoucherCustomer[] = [];
  private mOnlyCreateGiftVouchers: MGiftVoucher [] = [];
  private uiMode: string;
  private totalValues = new Map();

  @ViewChild('inputFormTGiftVoucherTransfer') inputFormTGiftVoucherTransfer;
  @ViewChild('inputFormTGiftVoucherTransferRequest') inputFormTGiftVoucherTransferRequest;

  constructor(private tGiftVoucherTransferService: TGiftVoucherTransferService,
              private snotifyService: SnotifyService,
              public ngxSmartModalService: NgxSmartModalService,
              private spinner: NgxSpinnerService,
              private mBranchService: MBranchService,
              private  mGiftVoucherPriceCategoryService: MGiftvoucherPriceCategoryService,
              private mBulkGiftVoucherCustomerService: MBulkGiftVoucherCustomerService,
              private mGiftVoucherService: MGiftVoucherService) {
    this.tGiftVoucherTransfer = new MainTGiftVoucherTransfer();
    this.tGiftVoucherTransferRequest = new TGiftVoucherTransferRequest();
  }

  ngOnInit() {
    this.spinner.show();
    this.loadMBranch();
    this.loadMGiftVoucherPriceCategory();
    this.loadMBulkGiftVoucherCustomer();
    this.uiMode = 'IDEAL';
    this.tGiftVoucherTransfer.giftVoucherType = 'NORMAL_GIFT_VOUCHER';
    setTimeout(() => {
      this.spinner.hide();
    }, 2000);
  }

  changeGiftVoucherType(giftVoucherType: string) {
    if (giftVoucherType === 'NORMAL_GIFT_VOUCHER') {
      this.tGiftVoucherTransfer.giftVoucherBulkCustomerCommisionP = 0;
      this.tGiftVoucherTransfer.giftVoucherBulkCustomerCommisionV = 0;
      this.tGiftVoucherTransfer.mBulkGiftVoucherCustomer = null;
    }
  }

  selectGiftVoucher(mGiftVoucher: MGiftVoucher): void {
    if (mGiftVoucher.printStatus) {
      mGiftVoucher.printStatus = false;
    } else {
      mGiftVoucher.printStatus = true;
    }

    this.tGiftVoucherTransferRequest.tGiftVoucherTransferItemList = [];
    var selectMGiftVoucherCount: number = 0;
    for (var mGiftVouchers of this.mOnlyCreateGiftVouchers) {
      if (mGiftVouchers.printStatus === false) {
        selectMGiftVoucherCount += 1;
      }
    }
    this.tGiftVoucherTransferRequest.requestQty = selectMGiftVoucherCount;
  }

  addMainTGiftVoucherTransferRequest(): void {
    if (this.tGiftVoucherTransfer.giftVoucherType === 'GIFT_VOUCHER_BULK_CUSTOMER') {
      if (!this.tGiftVoucherTransfer.mBulkGiftVoucherCustomer) {
        this.snotifyService.error('Please Select Gift Voucher Bulk Customer!', AppSettings.MESSAGE_ERROR, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (!this.tGiftVoucherTransferRequest.mGiftVoucherPriceCategory) {
        this.snotifyService.error('Please Select Gift Voucher Price Category!', AppSettings.MESSAGE_ERROR, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (!this.tGiftVoucherTransferRequest.requestQty) {
        this.snotifyService.error('Please Enter Gift Voucher Request Qty!', AppSettings.MESSAGE_ERROR, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (this.tGiftVoucherTransferRequest.requestQty > this.tGiftVoucherTransferRequest.totalStockQty) {
        this.snotifyService.error('Please Enter Valid Request Qty!', AppSettings.MESSAGE_ERROR, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (this.tGiftVoucherTransferRequest.requestQty === 0) {
        this.snotifyService.error('Please Create And Print Gift Voucher', AppSettings.MESSAGE_ERROR, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else {
        this.mOnlyCreateGiftVouchers = [];
        this.mGiftVoucherService.findOnlyCreateByPriceCategoryAndBulkCustomer(this.tGiftVoucherTransferRequest.mGiftVoucherPriceCategory.indexNo, this.tGiftVoucherTransfer.mBulkGiftVoucherCustomer.indexNo).subscribe((data) => {
          this.mOnlyCreateGiftVouchers = data;
          for (var i = 0; i < this.tGiftVoucherTransferRequest.requestQty; i++) {
            var item = this.mOnlyCreateGiftVouchers[i];
            item.printStatus = false;
          }
          this.ngxSmartModalService.open('popupOne');
        }, (e) => {
          this.snotifyService.error(e.error.message, AppSettings.MESSAGE_ERROR, {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true
          });
        });
      }
    } else {
      if (!this.tGiftVoucherTransferRequest.mGiftVoucherPriceCategory) {
        this.snotifyService.error('Please Select Gift Voucher Price Category!', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (!this.tGiftVoucherTransferRequest.requestQty) {
        this.snotifyService.error('Please Enter Gift Voucher Request Qty!', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (this.tGiftVoucherTransferRequest.requestQty > this.tGiftVoucherTransferRequest.totalStockQty) {
        this.snotifyService.error('Please Enter Valid Request Qty!', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (this.tGiftVoucherTransferRequest.requestQty === 0) {
        this.snotifyService.error('Please Create And Print Gift Voucher', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else {
        this.mOnlyCreateGiftVouchers = [];
        this.mGiftVoucherService.findOnlyCreateByPriceCategoryAndBranch(this.tGiftVoucherTransferRequest.mGiftVoucherPriceCategory.indexNo, this.tGiftVoucherTransfer.fromBranch.indexNo).subscribe((data) => {
          this.mOnlyCreateGiftVouchers = data;
          for (var i = 0; i < this.tGiftVoucherTransferRequest.requestQty; i++) {
            var item = this.mOnlyCreateGiftVouchers[i];
            item.printStatus = false;
          }
          this.ngxSmartModalService.open('popupOne');
        }, (e) => {
          this.snotifyService.error('This Gift Voucher Price Category And Branch Has Gift Vouchers Empty!', AppSettings.MESSAGE_ERROR, {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true
          });
        });
      }
    }
  }

  addIGiftVoucherRequestItems(): void {
    this.tGiftVoucherTransferRequest.tGiftVoucherTransferItemList = [];
    for (var mGiftVouchers of this.mOnlyCreateGiftVouchers) {
      if (mGiftVouchers.printStatus === false) {
        //add requst item
        var tGiftVoucherTransferItem: TGiftVoucherTransferItem = new TGiftVoucherTransferItem();
        tGiftVoucherTransferItem.mGiftVoucher = mGiftVouchers;
        this.tGiftVoucherTransferRequest.tGiftVoucherTransferItemList.push(tGiftVoucherTransferItem);
      }
    }
    //add request
    this.tGiftVoucherTransfer.tGiftVoucherTransferRequestList.unshift(this.tGiftVoucherTransferRequest);
    this.tGiftVoucherTransfer.status = 'PENDING';
    this.tGiftVoucherTransferRequest = new TGiftVoucherTransferRequest();
    this.getGiftVoucherTransferRequestTotal();

    this.ngxSmartModalService.close('popupOne');
    this.getGiftVoucherTransferRequestTotal();
  }

  getTotalGiftVoucherStockQty(mGiftVoucherPriceCategory) {
    if (this.tGiftVoucherTransfer.giftVoucherType === 'GIFT_VOUCHER_BULK_CUSTOMER') {
      this.mOnlyCreateGiftVouchers = [];
      this.mGiftVoucherService.findOnlyCreateByPriceCategoryAndBulkCustomer(mGiftVoucherPriceCategory.item.indexNo, this.tGiftVoucherTransfer.mBulkGiftVoucherCustomer.indexNo).subscribe((data) => {
        this.tGiftVoucherTransferRequest.totalStockQty = data.length;
      }, (e) => {
        this.snotifyService.error('!', AppSettings.MESSAGE_ERROR, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      });
    } else {
      this.mOnlyCreateGiftVouchers = [];
      this.mGiftVoucherService.findOnlyCreateByPriceCategoryAndBranch(mGiftVoucherPriceCategory.item.indexNo, this.tGiftVoucherTransfer.fromBranch.indexNo).subscribe((data) => {
        this.tGiftVoucherTransferRequest.totalStockQty = data.length;
      }, (e) => {
        this.snotifyService.error('This Gift Voucher Price Category And Branch Has Gift Vouchers Empty!', 'ERROR', {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      });
    }
  }

  editMainTGiftVoucherTransferRequest(rowNo, tGiftVoucherTransferRequest: TGiftVoucherTransferRequest): void {
    this.tGiftVoucherTransferRequest = tGiftVoucherTransferRequest;
    this.tGiftVoucherTransfer.tGiftVoucherTransferRequestList.splice(rowNo, 1);
  }

  deleteMainTGiftVoucherTransferRequest(rowNo: number) {
    this.tGiftVoucherTransfer.tGiftVoucherTransferRequestList.splice(rowNo, 1);
    this.getGiftVoucherTransferRequestTotal();
  }

  viewTGiftVoucher(rowNo, tGiftVoucherTransferRequest: TGiftVoucherTransferRequest): void {
    this.tGiftVoucherTransferItems = tGiftVoucherTransferRequest.tGiftVoucherTransferItemList;
    this.ngxSmartModalService.open('tGiftVoucherRequestItemView');
  }

  findByTransactionNumber(): void {
    if (typeof this.tGiftVoucherTransfer.transactionNumber !== undefined) {
      if (!this.tGiftVoucherTransfer.transactionNumber) {
        this.snotifyService.error('Please Enter Trasaction Number', 'ERROR', {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
        this.tGiftVoucherTransfer = new MainTGiftVoucherTransfer();
      } else {
        this.tGiftVoucherTransferService.findByTransactionNumber(this.tGiftVoucherTransfer.transactionNumber).subscribe((data) => {
            this.tGiftVoucherTransfer = data;
            this.tGiftVoucherTransfer.transactionDate = new Date(this.tGiftVoucherTransfer.transactionDate).toISOString().slice(0, 16);
            this.uiMode = 'SELECTED';
            this.getGiftVoucherTransferRequestTotal();
          },
          (e) => {
            this.snotifyService.error(e.error.message, 'ERROR', {
              timeout: 2000,
              showProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true
            });
            this.tGiftVoucherTransfer = new MainTGiftVoucherTransfer();
          });
      }
    }
  }

  getBulkCustomerCommisionValue(): void {
    this.tGiftVoucherTransfer.giftVoucherBulkCustomerCommisionV = 0;
    var totalAmount: number = this.totalValues.get('totalValue');
    if (totalAmount > 0) {
      if (this.tGiftVoucherTransfer.giftVoucherBulkCustomerCommisionP) {
        this.tGiftVoucherTransfer.giftVoucherBulkCustomerCommisionV = (totalAmount * this.tGiftVoucherTransfer.giftVoucherBulkCustomerCommisionP) / 100;
      }
    }
  }

  getBulkCustomerCommisionPrcentage(): void {
    this.tGiftVoucherTransfer.giftVoucherBulkCustomerCommisionP = 0;
    var totalAmount: number = this.totalValues.get('totalValue');
    if (totalAmount > 0) {
      if (this.tGiftVoucherTransfer.giftVoucherBulkCustomerCommisionV) {
        this.tGiftVoucherTransfer.giftVoucherBulkCustomerCommisionP = (this.tGiftVoucherTransfer.giftVoucherBulkCustomerCommisionV * 100) / totalAmount;
      }
    }
  }

  getGiftVoucherTransferRequestTotal(): void {
    this.totalValues = new Map();
    var totalRequest: number = 0;
    var totalValue: number = 0;
    this.totalValues.set('totalRow', this.tGiftVoucherTransfer.tGiftVoucherTransferRequestList.length);

    for (var tGiftVoucherTransferRequest of this.tGiftVoucherTransfer.tGiftVoucherTransferRequestList) {
      if (tGiftVoucherTransferRequest.requestQty) {
        totalRequest += tGiftVoucherTransferRequest.requestQty;
        totalValue += tGiftVoucherTransferRequest.requestQty * tGiftVoucherTransferRequest.mGiftVoucherPriceCategory.price;
      }
    }

    this.totalValues.set('totalValue', totalValue);
    this.totalValues.set('totalRequest', totalRequest);
  }

  formatterMBranch1 = (x: { name: string }) => x.name;
  searchMBranch1 = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? []
        : this.mBranchs.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );

  formatterMBranch2 = (x: { name: string }) => x.name;
  searchMBranch2 = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? []
        : this.mBranchs.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );

  formatterMGiftVoucherPriceCategory = (x: { price: string }) => x.price;
  searchMGiftVoucherPriceCategory = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? []
        : this.mGiftVoucherPriceCategorys.filter(v => v.price.toString().toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );

  formatterMGiftVoucherBulkCustomer = (x: { name: string }) => x.name;
  searchMGiftVoucherBulkCustomer = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? []
        : this.mBulkGiftVoucherCustomers.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );

  newFormData(): void {
    this.tGiftVoucherTransfer.transactionNumber = null;
    this.uiMode = 'EDIT';
    this.tGiftVoucherTransfer.transactionDate = new Date().toISOString().slice(0, 16);
  }

  sumbmitFormData(): void {
    if (this.tGiftVoucherTransfer.giftVoucherType === 'GIFT_VOUCHER_BULK_CUSTOMER') {
      if (!this.tGiftVoucherTransfer.mBulkGiftVoucherCustomer) {
        this.snotifyService.error('Please Select Gift Voucher Bulk Customer!', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else {
        if (this.tGiftVoucherTransfer.tGiftVoucherTransferRequestList.length === 0) {
          this.snotifyService.warning('Select Items', AppSettings.MESSAGE_WARNING, {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true
          });
        } else {
          this.snotifyService.confirm('Save ?..', AppSettings.MESSAGE_INFO, {
            timeout: 5000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            buttons: [
              {
                text: 'Yes', action: (toast) => {
                  this.snotifyService.remove(toast.id);
                  this.tGiftVoucherTransferService.save(this.tGiftVoucherTransfer).subscribe((tGiftVoucherTransfer) => {
                    this.snotifyService.success('Gift Voucher Trasfer Delete Success!', AppSettings.MESSAGE_SUCCESS, {
                      timeout: 2000,
                      showProgressBar: false,
                      closeOnClick: false,
                      pauseOnHover: true
                    });
                    this.clearFormData();
                  }, (e) => {
                    this.snotifyService.error(e.error.message, AppSettings.MESSAGE_ERROR, {
                      timeout: 2000,
                      showProgressBar: false,
                      closeOnClick: false,
                      pauseOnHover: true
                    });
                  });
                }
              },
              {
                text: 'No', action: (toast) => {
                  this.snotifyService.remove(toast.id);
                }, bold: true
              },
            ]
          });
        }
      }
    } else {
      if (!this.tGiftVoucherTransfer.fromBranch) {
        this.snotifyService.warning('Select From Branch', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else if (!this.tGiftVoucherTransfer.toBranch) {
        this.snotifyService.warning('Select To Branch', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });

      } else if (this.tGiftVoucherTransfer.toBranch === this.tGiftVoucherTransfer.fromBranch) {
        this.snotifyService.warning('From Branch And To Branch Same', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });

      } else {
        if (this.tGiftVoucherTransfer.tGiftVoucherTransferRequestList.length === 0) {
          this.snotifyService.warning('Select Items', AppSettings.MESSAGE_WARNING, {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true
          });
        } else {
          this.snotifyService.confirm('Save ?..', AppSettings.MESSAGE_INFO, {
            timeout: 5000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            buttons: [
              {
                text: 'Yes', action: (toast) => {
                  this.snotifyService.remove(toast.id);
                  this.tGiftVoucherTransferService.save(this.tGiftVoucherTransfer).subscribe((tGiftVoucherTransfer) => {
                    this.snotifyService.success('Gift Voucher Trasfer Delete Success!', AppSettings.MESSAGE_SUCCESS, {
                      timeout: 2000,
                      showProgressBar: false,
                      closeOnClick: false,
                      pauseOnHover: true
                    });
                    this.clearFormData();
                  }, (e) => {
                    this.snotifyService.error(e.error.message, AppSettings.MESSAGE_ERROR, {
                      timeout: 2000,
                      showProgressBar: false,
                      closeOnClick: false,
                      pauseOnHover: true
                    });
                  });
                }
              },
              {
                text: 'No', action: (toast) => {
                  this.snotifyService.remove(toast.id);
                }, bold: true
              },
            ]
          });
        }
      }
    }
  }

  clearFormData(): void {
    this.uiMode = 'IDEAL';
    this.loadMBranch();
    this.loadMGiftVoucherPriceCategory();
    this.loadMBulkGiftVoucherCustomer();
    this.tGiftVoucherTransfer = new MainTGiftVoucherTransfer();
    this.tGiftVoucherTransferRequest = new TGiftVoucherTransferRequest();
  }

  loadMBranch(): void {
    this.mBranchService.findByType('GIFT_VOUCHER').subscribe((data) => {
      this.mBranchs = data;
    }, (e) => {
      this.mBranchs = [];
    });
  }

  loadMGiftVoucherPriceCategory(): void {
    this.mGiftVoucherPriceCategoryService.findAll().subscribe((data) => {
      this.mGiftVoucherPriceCategorys = data;
    }, (e) => {
      this.mGiftVoucherPriceCategorys = [];
    });
  }

  loadMBulkGiftVoucherCustomer(): void {
    this.mBulkGiftVoucherCustomerService.findAll().subscribe((data) => {
        this.mBulkGiftVoucherCustomers = data;
      },
      (e) => {
        this.mBulkGiftVoucherCustomers = [];
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/view/transactions/t-gift-voucher-transfer/t-gift-voucher-transfer.component.ts